<template>
<v-layout column fill-height>
    <v-navigation-drawer
      persistent
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      width="250"
      :mini-variant="miniVariant"
      enable-resize-watcher
      fixed
      app
    >
      <v-list
      dense>
        <v-list-tile v-for="(item) in filteredItems" :key="item.url"
        :to="item.url"
        active-class="grey lighten-4 primary--text">
          <v-list-tile-action>
            <v-icon>{{item.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{item.title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
      clipped-left
      color="primary"
      dark
    >
      <v-btn icon @click.stop="$vuetify.breakpoint.lgAndUp ? miniVariant = !miniVariant : drawer = !drawer">
        <v-icon v-html="(miniVariant || !drawer) ? 'menu' : 'close'"></v-icon>
      </v-btn>
      <v-toolbar-title>
        <v-layout column justify-space-between fill-height>
          <img src="@/assets/alterna-ai-logo-white.png" height="60">
        </v-layout>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat> {{ $auth.user().name }} </v-btn>
        <v-spacer></v-spacer>
        <v-btn flat @click="logout">Logout</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content fill-height>
      <router-view :key="$route.fullPath"/>
    </v-content>
    <v-navigation-drawer
      temporary
      :right="right"
      v-model="rightDrawer"
      fixed
      app
    >
      <v-list>
        <v-list-tile @click="right = !right">
          <v-list-tile-action>
            <v-icon>compare_arrows</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Switch drawer (click me)</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-footer :fixed="fixed" app>
      <span class="ml-2">Powered by <a href="https://alternacx.com" target="blank" style="text-decoration: none;">Alterna CX </a>&copy; {{new Date().getFullYear()}}</span>
      <v-spacer></v-spacer>
      <span class="mr-2"> <router-link to="/version" style="text-decoration: none;"> {{version}} </router-link></span>
    </v-footer>
</v-layout>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Dashboard',
  data () {
    return {
      fixed: false,
      items: [{
        icon: 'folder',
        title: 'Datasets',
        url: '/datasets',
        scopes: ['dataset:read', 'dataset:manage']
      },
      {
        icon: 'collections_bookmark',
        title: 'Topic Models',
        url: '/topic-models',
        scopes: ['topic:read', 'topic:manage']
      },
      {
        icon: 'sentiment_satisfied',
        title: 'Sentiment Models',
        url: '/sentiment-models',
        scopes: ['sentiment:read', 'sentiment:manage']
      },
      {
        icon: 'schedule',
        title: 'Scheduled Jobs',
        url: '/scheduled-jobs',
        scopes: ['job:read', 'job:manage']
      },
      {
        icon: 'group',
        title: 'Users',
        url: '/users',
        scopes: ['system:manage']
      },
      {
        icon: 'group',
        title: 'Roles',
        url: '/roles',
        scopes: ['system:manage']
      },
      {
        icon: 'assignment',
        title: 'Annotation Works',
        url: '/annotation-works',
        scopes: ['annotation:read', 'annotation:manage']
      },
      {
        icon: 'assignment_ind',
        title: 'Annotators',
        url: '/annotators',
        scopes: ['annotation:read', 'annotation:manage']
      },
      {
        icon: 'settings_applications',
        title: 'System Configurations',
        url: '/system-configurations',
        scopes: ['system:manage']
      },
      {
        icon: 'table_chart',
        title: 'Logs',
        url: '/logs',
        scopes: ['system:manage']
      },
      {
        icon: 'health_and_safety',
        title: 'Health',
        url: '/health',
        scopes: ['system:manage']
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Alterna AI',
      drawer: true
    }
  },
  computed: {
    filteredItems () {
      return this.items.filter((i) => {
        return i.scopes.filter(s => this.$auth.user().AuthScope.includes(s)).length > 0
      })
    },
    ...mapState({
      version: state => state.configurations.version
    })
  },
  methods: {
    logout () {
      this.$auth.logout({
        makeRequest: false,
        redirect: '/login'
      })
    }
  }
}
</script>
